
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import { AppProviders } from "./app/providers/AppProviders";
import { initAnalytics } from "./lib/analytics/analytics";
import { initSentry } from "./lib/observability/sentry";
import { unregisterServiceWorker } from "./lib/pwa";
import "./styles/index.css";

initSentry();
initAnalytics();
unregisterServiceWorker();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
  
